import BentoGrid from "../components/BentoGrid";
import { cards } from "../components/CardGrid";

const Home = () => {
    return (
        <BentoGrid cards={cards} />
    );
};

export default Home;
